<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import NewsHeroSlider from '@/components/News/NewsHeroSlider.vue';
import NewsOtherSlider from '@/components/News/NewsOtherSlider.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  redSpot,
  hasRedSpot,
  hasAnyContent,
  template,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor && template !== 'article' ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <RedSpot
      v-if="hasRedSpot"
      :position-vertical="redSpot.vertical"
      :position-horizontal="redSpot.horizontal"
    />
    <div class="container">
      <NewsOtherSlider v-if="template === 'other'" :data="data" />
      <NewsHeroSlider v-else :data="data" />
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.news-slider {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
    text-align: center;
  }
  &__slider {
    .swiper {
      height: 100%;
      overflow: visible;
      width: 100%;
      @include media-breakpoint-up(md) {
        overflow: hidden;
      }
    }
    .swiper-slide {
      align-self: stretch;
      height: auto;
      max-width: calc(100vw - 48px);
      width: 320px;
      @include media-breakpoint-up(sm) {
        max-width: unset;
        width: 356px;
      }
      @include media-breakpoint-up(md) {
        width: 389px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 389);
      }
    }
  }
}
</style>
